import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07ab6245"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grammar-review__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.8327 9.99999H4.16602M4.16602 9.99999L9.99935 15.8333M4.16602 9.99999L9.99935 4.16666",
    stroke: "#475467",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "grammar-review__heading" }
const _hoisted_5 = { class: "grammar-review__title" }
const _hoisted_6 = {
  key: 0,
  class: "grammar-review__timestamp"
}
const _hoisted_7 = { class: "grammar-review" }
const _hoisted_8 = { class: "grammar-review__section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "grammar-review__label" }, "Question:", -1))
const _hoisted_10 = { class: "grammar-review__question-card" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "grammar-review__section" }
const _hoisted_14 = { class: "grammar-review__label" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 0,
  class: "grammar-review__section"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "grammar-review__label" }, "Correct answer:", -1))
const _hoisted_19 = { class: "grammar-review__answer grammar-review__answer--sentence is-correct" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 0,
  class: "grammar-review__section"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "grammar-review__label" }, "Question:", -1))
const _hoisted_24 = { class: "grammar-review__question-card" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  key: 0,
  class: "grammar-review__options"
}
const _hoisted_27 = { class: "grammar-review__option-label" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 0,
  class: "grammar-review__pill"
}
const _hoisted_30 = {
  key: 1,
  class: "grammar-review__pill is-correct"
}
const _hoisted_31 = {
  key: 1,
  class: "grammar-review__blanks"
}
const _hoisted_32 = { class: "grammar-review__blank-head" }
const _hoisted_33 = { class: "grammar-review__blank-key" }
const _hoisted_34 = { class: "grammar-review__options" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  key: 0,
  class: "grammar-review__pill"
}
const _hoisted_37 = {
  key: 1,
  class: "grammar-review__pill is-correct"
}
const _hoisted_38 = { class: "grammar-review__section" }
const _hoisted_39 = { class: "grammar-review__label" }
const _hoisted_40 = {
  key: 1,
  class: "grammar-review__section"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "grammar-review__label" }, "Correct answer:", -1))
const _hoisted_42 = { class: "grammar-review__answer is-correct" }

import { computed } from "vue";
import LingoModal from "@/modules/main/components/manage/LingoModalComponent.vue";
import type { ClozeAnswerView } from "@/modules/main/services/grammarRenderer";

interface GrammarReviewOption {
  label: string;
  text: string;
  html?: string;
  isSelected?: boolean;
  isCorrect?: boolean;
  state?: string;
}

interface GrammarReview {
  title: string;
  timestamp: string;
  promptHtml: string;
  itemType?: string;
  options: GrammarReviewOption[];
  blanks?: Array<any>;
  clozeView?: ClozeAnswerView | null;
  studentAnswer: string;
  correctAnswer: string;
  isCorrect: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GrammarAnswerReviewModal',
  props: {
    modelValue: { type: Boolean, default: false },
    review: { default: () => ({
    title: "",
    timestamp: "",
    promptHtml: "",
    options: [],
    blanks: [],
    clozeView: null,
    studentAnswer: "",
    correctAnswer: "",
    isCorrect: false
  }) }
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit }) {

const props = __props;





const internalValue = computed({
  get: () => props.modelValue,
  set: value => emit("update:modelValue", value)
});

// Present only for cloze dropdown; the caller builds it from the item's
// authored text, blanks and the learner's selections.
const clozeView = computed<ClozeAnswerView | null>(() => props.review?.clozeView || null);

const isPicklistReview = computed(() => props.review?.itemType === "picklist");

const studentAnswerLabel = computed(() =>
  props.review?.isCorrect ? "Student's answer (correct):" : "Student's answer:"
);

function close() {
  emit("update:modelValue", false);
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LingoModal, {
    modelValue: internalValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
    "show-close-button": true,
    "close-on-overlay": true,
    centered: true,
    size: "md",
    class: "grammar-review-modal"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "grammar-review__back",
          type: "button",
          onClick: close,
          "aria-label": "Back"
        }, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.review.title || "Question"), 1),
          (_ctx.review.timestamp)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.review.timestamp), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "grammar-review__close-btn",
        type: "button",
        onClick: close
      }, "Close")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        (clozeView.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("section", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  (clozeView.value.instructionHtml)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "grammar-review__sentence",
                        innerHTML: clozeView.value.instructionHtml
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", {
                    class: "grammar-review__sentence",
                    innerHTML: clozeView.value.questionHtml
                  }, null, 8, _hoisted_12)
                ])
              ]),
              _createElementVNode("section", _hoisted_13, [
                _createElementVNode("h3", _hoisted_14, _toDisplayString(studentAnswerLabel.value), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["grammar-review__answer grammar-review__answer--sentence", _ctx.review.isCorrect ? 'is-correct' : 'is-incorrect'])
                }, [
                  (_ctx.review.isCorrect && clozeView.value.instructionHtml)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "grammar-review__sentence",
                        innerHTML: clozeView.value.instructionHtml
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", {
                    class: "grammar-review__sentence",
                    innerHTML: clozeView.value.studentHtml
                  }, null, 8, _hoisted_16)
                ], 2)
              ]),
              (!_ctx.review.isCorrect)
                ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      (clozeView.value.instructionHtml)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "grammar-review__sentence",
                            innerHTML: clozeView.value.instructionHtml
                          }, null, 8, _hoisted_20))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", {
                        class: "grammar-review__sentence",
                        innerHTML: clozeView.value.correctHtml
                      }, null, 8, _hoisted_21)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.review.promptHtml)
                ? (_openBlock(), _createElementBlock("section", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("p", {
                        class: "grammar-review__prompt",
                        innerHTML: _ctx.review.promptHtml
                      }, null, 8, _hoisted_25),
                      (_ctx.review.options && _ctx.review.options.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.review.options, (opt) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: opt.label,
                                class: _normalizeClass(["grammar-review__option", isPicklistReview.value ? 'is-neutral' : `is-${opt.state || 'neutral'}`])
                              }, [
                                _createElementVNode("span", _hoisted_27, _toDisplayString(opt.label), 1),
                                _createElementVNode("span", {
                                  class: "grammar-review__option-text",
                                  innerHTML: opt.html || opt.text
                                }, null, 8, _hoisted_28),
                                (!isPicklistReview.value && opt.isSelected)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Selected"))
                                  : _createCommentVNode("", true),
                                (!isPicklistReview.value && opt.isCorrect)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Correct"))
                                  : _createCommentVNode("", true)
                              ], 2))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.review.blanks && _ctx.review.blanks.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.review.blanks, (blank) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: blank.key,
                                class: "grammar-review__blank"
                              }, [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("span", _hoisted_33, "Blank " + _toDisplayString(blank.key), 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["grammar-review__pill", blank.isCorrect ? 'is-correct' : 'is-incorrect'])
                                  }, _toDisplayString(blank.isCorrect ? "Correct" : "Incorrect"), 3)
                                ]),
                                _createElementVNode("ul", _hoisted_34, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blank.options, (opt) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: `${blank.key}-${opt.label}`,
                                      class: _normalizeClass(["grammar-review__option", `is-${opt.state || 'neutral'}`])
                                    }, [
                                      _createElementVNode("span", {
                                        class: "grammar-review__option-text",
                                        innerHTML: opt.html || opt.text
                                      }, null, 8, _hoisted_35),
                                      (opt.isSelected)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Selected"))
                                        : _createCommentVNode("", true),
                                      (opt.isCorrect)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Correct"))
                                        : _createCommentVNode("", true)
                                    ], 2))
                                  }), 128))
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_38, [
                _createElementVNode("h3", _hoisted_39, _toDisplayString(studentAnswerLabel.value), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["grammar-review__answer", _ctx.review.isCorrect ? 'is-correct' : 'is-incorrect'])
                }, _toDisplayString(_ctx.review.studentAnswer || "—"), 3)
              ]),
              (!_ctx.review.isCorrect)
                ? (_openBlock(), _createElementBlock("section", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.review.correctAnswer || "—"), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})